import { AppBar, Box, Theme, SxProps } from "@mui/material";
import React, { useEffect, useState } from "react";
import { HeaderWelcome } from "./HeaderWelcome";
import { HeaderGoBack } from "./HeaderGoBack";
import { HeaderEditor } from "./HeaderEditor";
import { useDocumentOnboarding } from "@/hooks/skills/useDocumentOnboarding";
import { HeaderVariant } from "./constants";
import { Notifications } from "@/components/Notifications";

interface HeaderProps {
  variant: HeaderVariant.WELCOME | HeaderVariant.GO_BACK | HeaderVariant.EDITOR;
  chatWidth?: number;
  sx?: SxProps<Theme>;
  /**
   * @default "default"
   * @description Controls the height of the header
   * - default: 56px height (original size)
   * - narrow: 40px height (compact size)
   */
  size?: "default" | "narrow";
}

export const Header = ({ variant, chatWidth, sx, size = "default" }: HeaderProps) => {
  const { isOnboarding } = useDocumentOnboarding();
  const [showNotifications, setShowNotifications] = useState(true);

  const isNarrow = size === "narrow";

  useEffect(() => {
    if (isOnboarding) {
      setShowNotifications(false);
    } else {
      setShowNotifications(true);
    }
  }, [isOnboarding]);

  let Content;
  switch (variant) {
    case HeaderVariant.WELCOME:
      Content = <HeaderWelcome />;
      break;
    case HeaderVariant.GO_BACK:
      Content = <HeaderGoBack size={size} />;
      break;
    case HeaderVariant.EDITOR:
    default:
      Content = <HeaderEditor chatWidth={chatWidth ?? 400} />;
  }

  return (
    <AppBar
      position="static"
      sx={{
        height: isNarrow ? "40px" : "56px",
        backgroundColor: "white",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 24px",
        borderBottom: "1px solid",
        borderColor: "common.lightShade",
        zIndex: 1,
        boxShadow: "none",
        color: "common.black",
        ...sx,
      }}
      className="app-bar-header-page-layout"
    >
      {Content}

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: isNarrow ? "4px" : "8px",
          alignItems: "center",
        }}
      >
        {showNotifications && <Notifications size={size} />}
      </Box>
    </AppBar>
  );
};
